import { createSelector } from 'reselect'
import { ReduxState } from 'store/createRootReducer'
import featureStateSelector from './featureStateSelector'
import { SitesManagementState } from '../types'

export const errorSelector = createSelector<ReduxState, SitesManagementState, string | undefined>(
  featureStateSelector,
  state => state.UIState.error
)
